var MyStorage ={ 
    session_data : 'data',
    session_time : 'time',
    proxy : {},
    constructor :  function(){
        return this;
    },
    get :  function(name){
        var back = this.checkSessionTime(name)
        if(back === false){
            back = Cookies.get(name);
        }
        return back;
    },
    /** expire in days **/
    set : function(name,value,expire){
        Cookies.set(name, value, { expires: expire } );
        localStorage.setItem(name, JSON.stringify(this.createSessionData(value,expire)));
    },
    createSessionData : function(value,expire){
        var object = {};
        object[this.session_data] = value;
        object[this.session_time] = this.addTime(expire); 
        return object;           
    },
    checkSessionTime : function(name){
        if (!this.proxy.hasOwnProperty(name)) {
            var json = localStorage.getItem(name) === null ? false : localStorage.getItem(name);
            if(json === false){
                return false;
            }    
            json = JSON.parse(json);
            this.proxy[name] = (this.currentTime() < json[this.session_time]) || 1*json[this.session_time] == 0 ? json[this.session_data] : false;
        }
        return this.proxy[name];
    },
    currentTime: function(){
        return this.timeStamp(Date.now());
    },
    timeStamp: function(date){
        return Math.floor(date / 1000);
    },
    addTime: function(expire){
        expire = 86400000*expire;
        var ms = new Date().getTime() + expire;
        var tomorrow = new Date(ms);
        return this.timeStamp(tomorrow);
    }
}